// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-container .form-item .form-label[data-v-3211197d]{width:30%;float:left;text-align:right;line-height:36px;margin-right:10px}.form-container .form-item .warn[data-v-3211197d]{color:red}.form-container .form-item .form-input-item[data-v-3211197d]{width:60%;float:left}.tip[data-v-3211197d]{margin-bottom:30px;text-align:center}", ""]);
// Exports
module.exports = exports;
